import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["menu", "backdrop"];

  toggle() {
    const isOpening = this.menuTarget.classList.contains("hidden");
    this.menuTarget.classList.toggle("hidden");
    this.backdropTarget.classList.toggle("hidden");

    if (isOpening) {
      document.documentElement.classList.add("overflow-hidden");
      document.body.classList.add("overflow-hidden");
    } else {
      document.documentElement.classList.remove("overflow-hidden");
      document.body.classList.remove("overflow-hidden");
    }
  }

  disconnect() {
    this.menuTarget.classList.add("hidden");
    this.backdropTarget.classList.add("hidden");
    document.documentElement.classList.remove("overflow-hidden");
    document.body.classList.remove("overflow-hidden");
  }
}
